import React, { useState, useEffect } from "react";
import { Select, DatePicker, Input, Button, Form } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import Filterloader from "../../../components/loader";
import * as zoneActions from "../../../redux/actions/zone.actions";
import * as actionPage from "../../../redux/actions/work.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import moment from "moment";


const WorkFilters = (props) => {
  // console.log(props);
  const { onFilterChange } = props;
  const [form] = Form.useForm();
  const [postDataZone, setPostDataZone] = useState(null);
  const [postDataZoneIdsAll, setPostDataZoneIdsAll] = useState([]);

  // Load zone list on mount
  useEffect(() => {
    props.zoneActions.getZoneListAction();
  }, []);

  // Populate zone options when zoneData updates
  useEffect(() => {
    if (props.zoneData) {
      const zoneData = [];
      const zoneDataAll = [];
      props.zoneData.map((item) => {
        zoneData.push({ value: item?.storeId, label: item?.zoneName });
        zoneDataAll.push(item?.storeId);
      });
      setPostDataZoneIdsAll(zoneDataAll);
      setPostDataZone([{ value: "all", label: "---SELECT ALL---" }, ...zoneData]);
    }
  }, [props.zoneData]);

  // Sync existing filters from redux into form
  useEffect(() => {
    if (props.pageFilter) {
      form.setFieldsValue(props.pageFilter || null);
    }
  }, [props.pageFilter]);

  // Search / Filter handler
  const filterChange = async (value) => {
    const newData = {
      ...props.pageFilter,
      ...value,
      page: 1,
    };
    if (Array.isArray(newData.status)) {
      newData.status = newData.status.join(",");
    }
    if (Array.isArray(newData.storeId)) {
      newData.storeId = newData.storeId.join(",");
    }
    await props.actionPage.ItemLevelInventoryFiltersPagination(newData);
    if (onFilterChange) onFilterChange(newData);
  };

  const onChangeHandelZone = (value) => {
    if (value?.includes("all")) {
      form.setFieldsValue({
        ...props.workFilter,
        storeId: postDataZoneIdsAll,
      });
    }
  };
  
  // Reset handler
  const resetSearch = async () => {
    const today = moment();
    const newData = {
      page: 1,
      limit: 10,
      orderCreationDate: [moment(), moment()],
      status: "",
      storeId: "", 
      sort: "desc",
    };
    form.resetFields();
    form.setFieldsValue({
      orderCreationDate: [today, today],
    });
    await props.actionPage.getWorkFiltersPaginationAction(newData);
    if (onFilterChange) onFilterChange(newData);
  };

  return props?.pageLoading ? (
    <Filterloader />
  ) : (
    <Form
      form={form}
      className="fliters_form"
      onFinish={filterChange}
      layout="vertical"
      initialValues={{
        orderCreationDate: [moment(), moment()], // set today as default
      }}
    >

      <Form.Item name={["item_number"]} label={"Item Number"}>
        <Input allowClear style={{ width: 150 }} placeholder="Item Number" />
      </Form.Item>

      <Form.Item name={["configuration"]} label={"Configuration"}>
        <Input allowClear style={{ width: 150 }} placeholder="Configuration" />
      </Form.Item>

      {/* <Form.Item name={["store_id"]} label={"Store Id"}>
        <Input allowClear style={{ width: 150 }} placeholder="Store Id" />
      </Form.Item> */}

      <Form.Item name={["store_id"]} label={"Zone"}>
        <Select
          showSearch
          allowClear
          mode="multiple"
          optionFilterProp="children"
          filterOption={(input, option)=>(option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
          options={postDataZone}
          style={{ minWidth: 300 }}
          placeholder="Zone"
          onChange={onChangeHandelZone}
        />
      </Form.Item>

      <Button htmlType="submit" loading={props?.pageLoading}>
        Search <SearchOutlined />
      </Button>
      <Button loading={props?.pageLoading} onClick={resetSearch}>
        Reset
      </Button>
    </Form>
  );
};

const mapStateToProps = (state) => {
  return {
    zoneData: state.ZoneReducer.zoneData,
    workData: state.WorkReducer.workData,
    workPagination: state.WorkReducer.workPagination,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    zoneActions: bindActionCreators(zoneActions, dispatch),
    actionPage: bindActionCreators(actionPage, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WorkFilters);
